import { sortByLocaleCompare } from '@gilbarbara/helpers';

export const iconsPack = [
  { name: 'alarm' as const, categories: ['devices'] },
  { name: 'album' as const, categories: ['multimedia'] },
  { name: 'align-bottom' as const, categories: ['layout'] },
  { name: 'align-center' as const, categories: ['layout'] },
  { name: 'align-left' as const, categories: ['layout'] },
  { name: 'align-middle' as const, categories: ['layout'] },
  { name: 'align-right' as const, categories: ['layout'] },
  { name: 'align-top' as const, categories: ['layout'] },
  { name: 'anchor' as const, categories: ['ui'] },
  { name: 'apple-watch' as const, categories: ['devices'] },
  { name: 'arrange-back' as const, categories: ['layout'] },
  { name: 'arrange-front' as const, categories: ['layout'] },
  { name: 'arrow-align-h' as const, categories: ['arrows'] },
  { name: 'arrow-align-v' as const, categories: ['arrows'] },
  { name: 'arrow-bottom-left-o' as const, categories: ['arrows', 'circle'] },
  { name: 'arrow-bottom-left-r' as const, categories: ['arrows', 'square'] },
  { name: 'arrow-bottom-left' as const, categories: ['arrows'] },
  { name: 'arrow-bottom-right-o' as const, categories: ['arrows', 'circle'] },
  { name: 'arrow-bottom-right-r' as const, categories: ['arrows', 'square'] },
  { name: 'arrow-bottom-right' as const, categories: ['arrows'] },
  { name: 'arrow-down-o' as const, categories: ['arrows', 'circle'] },
  { name: 'arrow-down-r' as const, categories: ['arrows', 'square'] },
  { name: 'arrow-down' as const, categories: ['arrows'] },
  { name: 'arrow-left-o' as const, categories: ['arrows', 'circle'] },
  { name: 'arrow-left-r' as const, categories: ['arrows', 'square'] },
  { name: 'arrow-left' as const, categories: ['arrows'] },
  { name: 'arrow-long-down-c' as const, categories: ['arrows'] },
  { name: 'arrow-long-down-e' as const, categories: ['arrows'] },
  { name: 'arrow-long-down-l' as const, categories: ['arrows'] },
  { name: 'arrow-long-down-r' as const, categories: ['arrows'] },
  { name: 'arrow-long-down' as const, categories: ['arrows'] },
  { name: 'arrow-long-left-c' as const, categories: ['arrows'] },
  { name: 'arrow-long-left-e' as const, categories: ['arrows'] },
  { name: 'arrow-long-left-l' as const, categories: ['arrows'] },
  { name: 'arrow-long-left-r' as const, categories: ['arrows'] },
  { name: 'arrow-long-left' as const, categories: ['arrows'] },
  { name: 'arrow-long-right-c' as const, categories: ['arrows'] },
  { name: 'arrow-long-right-e' as const, categories: ['arrows'] },
  { name: 'arrow-long-right-l' as const, categories: ['arrows'] },
  { name: 'arrow-long-right-r' as const, categories: ['arrows'] },
  { name: 'arrow-long-right' as const, categories: ['arrows'] },
  { name: 'arrow-long-up-c' as const, categories: ['arrows'] },
  { name: 'arrow-long-up-e' as const, categories: ['arrows'] },
  { name: 'arrow-long-up-l' as const, categories: ['arrows'] },
  { name: 'arrow-long-up-r' as const, categories: ['arrows'] },
  { name: 'arrow-long-up' as const, categories: ['arrows'] },
  { name: 'arrow-right-o' as const, categories: ['arrows', 'circle'] },
  { name: 'arrow-right-r' as const, categories: ['arrows', 'square'] },
  { name: 'arrow-right' as const, categories: ['arrows'] },
  { name: 'arrow-top-left-o' as const, categories: ['arrows', 'circle'] },
  { name: 'arrow-top-left-r' as const, categories: ['arrows', 'square'] },
  { name: 'arrow-top-left' as const, categories: ['arrows'] },
  { name: 'arrow-top-right-o' as const, categories: ['arrows', 'circle'] },
  { name: 'arrow-top-right-r' as const, categories: ['arrows', 'square'] },
  { name: 'arrow-top-right' as const, categories: ['arrows'] },
  { name: 'arrow-up-o' as const, categories: ['arrows', 'circle'] },
  { name: 'arrow-up-r' as const, categories: ['arrows', 'square'] },
  { name: 'arrow-up' as const, categories: ['arrows'] },
  { name: 'arrows-breake-h' as const, categories: ['arrows'] },
  { name: 'arrows-breake-v' as const, categories: ['arrows'] },
  { name: 'arrows-exchange-alt-v' as const, categories: ['arrows'] },
  { name: 'arrows-exchange-alt' as const, categories: ['arrows'] },
  { name: 'arrows-exchange-v' as const, categories: ['arrows'] },
  { name: 'arrows-exchange' as const, categories: ['arrows'] },
  { name: 'arrows-expand-down-left' as const, categories: ['arrows'] },
  { name: 'arrows-expand-down-right' as const, categories: ['arrows'] },
  { name: 'arrows-expand-left-alt' as const, categories: ['arrows'] },
  { name: 'arrows-expand-left' as const, categories: ['arrows'] },
  { name: 'arrows-expand-right-alt' as const, categories: ['arrows'] },
  { name: 'arrows-expand-right' as const, categories: ['arrows'] },
  { name: 'arrows-expand-up-left' as const, categories: ['arrows'] },
  { name: 'arrows-expand-up-right' as const, categories: ['arrows'] },
  { name: 'arrows-h-alt' as const, categories: ['arrows'] },
  { name: 'arrows-h' as const, categories: ['arrows'] },
  { name: 'arrows-merge-alt-h' as const, categories: ['arrows'] },
  { name: 'arrows-merge-alt-v' as const, categories: ['arrows'] },
  { name: 'arrows-scroll-h' as const, categories: ['arrows'] },
  { name: 'arrows-scroll-v' as const, categories: ['arrows'] },
  { name: 'arrows-shrink-h' as const, categories: ['arrows'] },
  { name: 'arrows-shrink-v' as const, categories: ['arrows'] },
  { name: 'arrows-v-alt' as const, categories: ['arrows'] },
  { name: 'arrows-v' as const, categories: ['arrows'] },
  { name: 'assign' as const, categories: ['ui'] },
  { name: 'asterisk' as const, categories: ['misc'] },
  { name: 'attachment' as const, categories: ['ui'] },
  { name: 'attribution' as const, categories: ['multimedia'] },
  { name: 'awards' as const, categories: ['misc'] },
  { name: 'backspace' as const, categories: ['arrows'] },
  { name: 'band-aid' as const, categories: ['misc'] },
  { name: 'battery' as const, categories: ['devices'] },
  { name: 'battery-empty' as const, categories: ['devices'] },
  { name: 'battery-full' as const, categories: ['devices'] },
  { name: 'bell' as const, categories: ['ui'] },
  { name: 'board' as const, categories: ['ui'] },
  { name: 'bolt' as const, categories: ['misc'] },
  { name: 'bookmark' as const, categories: ['ui'] },
  { name: 'border-all' as const, categories: ['layout'] },
  { name: 'border-bottom' as const, categories: ['layout'] },
  { name: 'border-left' as const, categories: ['layout'] },
  { name: 'border-right' as const, categories: ['layout'] },
  { name: 'border-style-dashed' as const, categories: ['layout'] },
  { name: 'border-style-dotted' as const, categories: ['layout'] },
  { name: 'border-style-solid' as const, categories: ['layout'] },
  { name: 'border-top' as const, categories: ['layout'] },
  { name: 'bot' as const, categories: ['misc'] },
  { name: 'bowl' as const, categories: ['misc'] },
  { name: 'box' as const, categories: ['ui'] },
  { name: 'boy' as const, categories: ['ui'] },
  { name: 'briefcase' as const, categories: ['ui'] },
  { name: 'browse' as const, categories: ['ui'] },
  { name: 'browser' as const, categories: ['ui'] },
  { name: 'brush' as const, categories: ['ui'] },
  { name: 'bulb' as const, categories: ['misc'] },
  { name: 'calculator' as const, categories: ['devices'] },
  { name: 'calendar-dates' as const, categories: ['date'] },
  { name: 'calendar-due' as const, categories: ['date'] },
  { name: 'calendar-next' as const, categories: ['date'] },
  { name: 'calendar-today' as const, categories: ['date'] },
  { name: 'calendar-two' as const, categories: ['date'] },
  { name: 'calendar' as const, categories: ['date'] },
  { name: 'calibrate' as const, categories: ['misc'] },
  { name: 'cap' as const, categories: ['misc'] },
  { name: 'captions' as const, categories: ['ui'] },
  { name: 'card-clubs' as const, categories: ['misc'] },
  { name: 'card-diamonds' as const, categories: ['misc'] },
  { name: 'card-hearts' as const, categories: ['misc'] },
  { name: 'card-spades' as const, categories: ['misc'] },
  { name: 'carousel' as const, categories: ['ui'] },
  { name: 'cast' as const, categories: ['ui'] },
  { name: 'chart' as const, categories: ['ui'] },
  { name: 'check-o' as const, categories: ['ui', 'circle'] },
  { name: 'check-r' as const, categories: ['ui', 'square'] },
  { name: 'chevron-double-down-o' as const, categories: ['arrows', 'circle'] },
  { name: 'chevron-double-down-r' as const, categories: ['arrows', 'square'] },
  { name: 'chevron-double-left-o' as const, categories: ['arrows', 'circle'] },
  { name: 'chevron-double-left-r' as const, categories: ['arrows', 'square'] },
  { name: 'chevron-double-right-o' as const, categories: ['arrows', 'circle'] },
  { name: 'chevron-double-right-r' as const, categories: ['arrows', 'square'] },
  { name: 'chevron-double-up-o' as const, categories: ['arrows', 'circle'] },
  { name: 'chevron-double-up-r' as const, categories: ['arrows', 'square'] },
  { name: 'chevron-down-o' as const, categories: ['arrows', 'circle'] },
  { name: 'chevron-down-r' as const, categories: ['arrows', 'square'] },
  { name: 'chevron-down' as const, categories: ['arrows'] },
  { name: 'chevron-left-o' as const, categories: ['arrows', 'circle'] },
  { name: 'chevron-left-r' as const, categories: ['arrows', 'square'] },
  { name: 'chevron-left' as const, categories: ['arrows'] },
  { name: 'chevron-right-o' as const, categories: ['arrows', 'circle'] },
  { name: 'chevron-right-r' as const, categories: ['arrows', 'square'] },
  { name: 'chevron-right' as const, categories: ['arrows'] },
  { name: 'chevron-up-o' as const, categories: ['arrows', 'circle'] },
  { name: 'chevron-up-r' as const, categories: ['arrows', 'square'] },
  { name: 'chevron-up' as const, categories: ['arrows'] },
  { name: 'clapper-board' as const, categories: ['multimedia'] },
  { name: 'clipboard' as const, categories: ['ui'] },
  { name: 'close-o' as const, categories: ['ui', 'circle'] },
  { name: 'close-r' as const, categories: ['ui', 'square'] },
  { name: 'close' as const, categories: ['ui'] },
  { name: 'cloud' as const, categories: ['ui'] },
  { name: 'code' as const, categories: ['development'] },
  { name: 'code-slash' as const, categories: ['development'] },
  { name: 'coffee' as const, categories: ['misc'] },
  { name: 'collage' as const, categories: ['ui'] },
  { name: 'color-bucket' as const, categories: ['ui'] },
  { name: 'color-picker' as const, categories: ['ui'] },
  { name: 'comment' as const, categories: ['ui'] },
  { name: 'community' as const, categories: ['misc'] },
  { name: 'components' as const, categories: ['ui'] },
  { name: 'compress-left' as const, categories: ['arrows'] },
  { name: 'compress-right' as const, categories: ['arrows'] },
  { name: 'compress-v' as const, categories: ['arrows'] },
  { name: 'compress' as const, categories: ['arrows'] },
  { name: 'controller' as const, categories: ['ui'] },
  { name: 'copy' as const, categories: ['ui'] },
  { name: 'copyright' as const, categories: ['ui'] },
  { name: 'corner-double-down-left' as const, categories: ['arrows'] },
  { name: 'corner-double-down-right' as const, categories: ['arrows'] },
  { name: 'corner-double-left-down' as const, categories: ['arrows'] },
  { name: 'corner-double-left-up' as const, categories: ['arrows'] },
  { name: 'corner-double-right-down' as const, categories: ['arrows'] },
  { name: 'corner-double-right-up' as const, categories: ['arrows'] },
  { name: 'corner-double-up-left' as const, categories: ['arrows'] },
  { name: 'corner-double-up-right' as const, categories: ['arrows'] },
  { name: 'corner-down-left' as const, categories: ['arrows'] },
  { name: 'corner-down-right' as const, categories: ['arrows'] },
  { name: 'corner-left-down' as const, categories: ['arrows'] },
  { name: 'corner-left-up' as const, categories: ['arrows'] },
  { name: 'corner-right-down' as const, categories: ['arrows'] },
  { name: 'corner-right-up' as const, categories: ['arrows'] },
  { name: 'corner-up-left' as const, categories: ['arrows'] },
  { name: 'corner-up-right' as const, categories: ['arrows'] },
  { name: 'credit-card' as const, categories: ['misc'] },
  { name: 'crop' as const, categories: ['ui'] },
  { name: 'crown' as const, categories: ['misc'] },
  { name: 'dark-mode' as const, categories: ['ui'] },
  { name: 'data' as const, categories: ['multimedia'] },
  { name: 'database' as const, categories: ['ui'] },
  { name: 'debug' as const, categories: ['development'] },
  { name: 'desktop' as const, categories: ['ui'] },
  { name: 'details-less' as const, categories: ['layout'] },
  { name: 'details-more' as const, categories: ['layout'] },
  { name: 'dialpad' as const, categories: ['ui'] },
  { name: 'dice-1' as const, categories: ['misc'] },
  { name: 'dice-2' as const, categories: ['misc'] },
  { name: 'dice-3' as const, categories: ['misc'] },
  { name: 'dice-4' as const, categories: ['misc'] },
  { name: 'dice-5' as const, categories: ['misc'] },
  { name: 'dice-6' as const, categories: ['misc'] },
  { name: 'disc' as const, categories: ['multimedia'] },
  { name: 'display-flex' as const, categories: ['layout'] },
  { name: 'display-fullwidth' as const, categories: ['layout'] },
  { name: 'display-grid' as const, categories: ['layout'] },
  { name: 'display-spacing' as const, categories: ['layout'] },
  { name: 'distribute-horizontal' as const, categories: ['layout'] },
  { name: 'distribute-vertical' as const, categories: ['layout'] },
  { name: 'dock-bottom' as const, categories: ['ui'] },
  { name: 'dock-left' as const, categories: ['ui'] },
  { name: 'dock-right' as const, categories: ['ui'] },
  { name: 'dock-window' as const, categories: ['ui'] },
  { name: 'dollar' as const, categories: ['misc'] },
  { name: 'drive' as const, categories: ['devices'] },
  { name: 'drop-invert' as const, categories: ['ui'] },
  { name: 'drop-opacity' as const, categories: ['ui'] },
  { name: 'drop' as const, categories: ['ui'] },
  { name: 'duplicate' as const, categories: ['ui'] },
  { name: 'edit-black-point' as const, categories: ['ui'] },
  { name: 'edit-contrast' as const, categories: ['ui'] },
  { name: 'edit-exposure' as const, categories: ['ui'] },
  { name: 'edit-fade' as const, categories: ['ui'] },
  { name: 'edit-flip-h' as const, categories: ['ui'] },
  { name: 'edit-flip-v' as const, categories: ['ui'] },
  { name: 'edit-highlight' as const, categories: ['ui'] },
  { name: 'edit-markup' as const, categories: ['ui'] },
  { name: 'edit-mask' as const, categories: ['ui'] },
  { name: 'edit-noise' as const, categories: ['ui'] },
  { name: 'edit-shadows' as const, categories: ['ui'] },
  { name: 'edit-straight' as const, categories: ['ui'] },
  { name: 'edit-unmask' as const, categories: ['ui'] },
  { name: 'eject' as const, categories: ['ui'] },
  { name: 'enter' as const, categories: ['ui'] },
  { name: 'erase' as const, categories: ['ui'] },
  { name: 'ereader' as const, categories: ['devices'] },
  { name: 'ethernet' as const, categories: ['ui'] },
  { name: 'euro' as const, categories: ['misc'] },
  { name: 'expand' as const, categories: ['arrows'] },
  { name: 'export' as const, categories: ['ui'] },
  { name: 'extension-add' as const, categories: ['ui'] },
  { name: 'extension-alt' as const, categories: ['ui'] },
  { name: 'extension-remove' as const, categories: ['ui'] },
  { name: 'extension' as const, categories: ['ui'] },
  { name: 'external' as const, categories: ['ui'] },
  { name: 'eye-alt' as const, categories: ['ui'] },
  { name: 'eye' as const, categories: ['ui'] },
  { name: 'feed' as const, categories: ['ui'] },
  { name: 'file-add' as const, categories: ['ui'] },
  { name: 'file-document' as const, categories: ['ui'] },
  { name: 'file-remove' as const, categories: ['ui'] },
  { name: 'file' as const, categories: ['ui'] },
  { name: 'film' as const, categories: ['multimedia'] },
  { name: 'filters' as const, categories: ['ui'] },
  { name: 'flag-alt' as const, categories: ['ui'] },
  { name: 'flag' as const, categories: ['ui'] },
  { name: 'folder-add' as const, categories: ['ui'] },
  { name: 'folder-remove' as const, categories: ['ui'] },
  { name: 'folder' as const, categories: ['ui'] },
  { name: 'font-height' as const, categories: ['typography'] },
  { name: 'font-spacing' as const, categories: ['typography'] },
  { name: 'format-center' as const, categories: ['typography'] },
  { name: 'format-color' as const, categories: ['typography'] },
  { name: 'format-heading' as const, categories: ['typography'] },
  { name: 'format-indent-decrease' as const, categories: ['typography'] },
  { name: 'format-indent-increase' as const, categories: ['typography'] },
  { name: 'format-italic' as const, categories: ['typography'] },
  { name: 'format-justify' as const, categories: ['typography'] },
  { name: 'format-left' as const, categories: ['typography'] },
  { name: 'format-line-height' as const, categories: ['typography'] },
  { name: 'format-right' as const, categories: ['typography'] },
  { name: 'format-separator' as const, categories: ['typography'] },
  { name: 'format-slash' as const, categories: ['typography'] },
  { name: 'format-strike' as const, categories: ['typography'] },
  { name: 'format-text' as const, categories: ['typography'] },
  { name: 'format-underline' as const, categories: ['typography'] },
  { name: 'format-uppercase' as const, categories: ['typography'] },
  { name: 'games' as const, categories: ['devices'] },
  { name: 'gender-female' as const, categories: ['ui'] },
  { name: 'gender-male' as const, categories: ['ui'] },
  { name: 'gift' as const, categories: ['misc'] },
  { name: 'girl' as const, categories: ['ui'] },
  { name: 'git-branch' as const, categories: ['development'] },
  { name: 'git-commit' as const, categories: ['development'] },
  { name: 'git-fork' as const, categories: ['development'] },
  { name: 'git-pull' as const, categories: ['development'] },
  { name: 'glass-alt' as const, categories: ['misc'] },
  { name: 'globe-alt' as const, categories: ['ui'] },
  { name: 'globe' as const, categories: ['ui'] },
  { name: 'gym' as const, categories: ['misc'] },
  { name: 'hashtag' as const, categories: ['ui'] },
  { name: 'headset' as const, categories: ['devices', 'multimedia'] },
  { name: 'heart' as const, categories: ['ui'] },
  { name: 'hello' as const, categories: ['misc'] },
  { name: 'home-alt' as const, categories: ['ui'] },
  { name: 'home-screen' as const, categories: ['devices'] },
  { name: 'home' as const, categories: ['ui'] },
  { name: 'icecream' as const, categories: ['misc'] },
  { name: 'image' as const, categories: ['ui'] },
  { name: 'import' as const, categories: ['ui'] },
  { name: 'inbox' as const, categories: ['ui'] },
  { name: 'infinity' as const, categories: ['misc'] },
  { name: 'inpicture' as const, categories: ['multimedia'] },
  { name: 'insert-after-o' as const, categories: ['ui'] },
  { name: 'insert-after-r' as const, categories: ['ui'] },
  { name: 'insert-after' as const, categories: ['ui'] },
  { name: 'insert-before-o' as const, categories: ['ui'] },
  { name: 'insert-before-r' as const, categories: ['ui'] },
  { name: 'insert-before' as const, categories: ['ui'] },
  { name: 'insights' as const, categories: ['ui'] },
  { name: 'internal' as const, categories: ['ui'] },
  { name: 'key' as const, categories: ['ui'] },
  { name: 'keyboard' as const, categories: ['devices'] },
  { name: 'laptop' as const, categories: ['devices'] },
  { name: 'layout-grid-small' as const, categories: ['layout'] },
  { name: 'layout-grid' as const, categories: ['layout'] },
  { name: 'layout-list' as const, categories: ['layout'] },
  { name: 'layout-pin' as const, categories: ['layout'] },
  { name: 'link' as const, categories: ['ui'] },
  { name: 'list-tree' as const, categories: ['ui'] },
  { name: 'list' as const, categories: ['ui'] },
  { name: 'live-photo' as const, categories: ['multimedia'] },
  { name: 'lock-unlock' as const, categories: ['ui'] },
  { name: 'lock' as const, categories: ['ui'] },
  { name: 'log-in' as const, categories: ['ui'] },
  { name: 'log-off' as const, categories: ['ui'] },
  { name: 'log-out' as const, categories: ['ui'] },
  { name: 'loupe' as const, categories: ['ui'] },
  { name: 'magnet' as const, categories: ['misc'] },
  { name: 'mail-forward' as const, categories: ['ui'] },
  { name: 'mail-open' as const, categories: ['ui'] },
  { name: 'mail-reply' as const, categories: ['ui'] },
  { name: 'mail' as const, categories: ['ui'] },
  { name: 'math-divide' as const, categories: ['ui'] },
  { name: 'math-equal' as const, categories: ['ui'] },
  { name: 'math-minus' as const, categories: ['ui'] },
  { name: 'math-percent' as const, categories: ['ui'] },
  { name: 'math-plus' as const, categories: ['ui'] },
  { name: 'maximize-alt' as const, categories: ['ui'] },
  { name: 'maximize' as const, categories: ['ui'] },
  { name: 'media-live' as const, categories: ['multimedia'] },
  { name: 'media-podcast' as const, categories: ['multimedia'] },
  { name: 'menu-boxed' as const, categories: ['ui'] },
  { name: 'menu-cake' as const, categories: ['ui'] },
  { name: 'menu-cheese' as const, categories: ['ui'] },
  { name: 'menu-grid-o' as const, categories: ['ui'] },
  { name: 'menu-grid-r' as const, categories: ['ui'] },
  { name: 'menu-hotdog' as const, categories: ['ui'] },
  { name: 'menu-left-alt' as const, categories: ['ui'] },
  { name: 'menu-left' as const, categories: ['ui'] },
  { name: 'menu-motion' as const, categories: ['ui'] },
  { name: 'menu-oreos' as const, categories: ['ui'] },
  { name: 'menu-right-alt' as const, categories: ['ui'] },
  { name: 'menu-right' as const, categories: ['ui'] },
  { name: 'menu' as const, categories: ['ui'] },
  { name: 'merge-horizontal' as const, categories: ['ui'] },
  { name: 'merge-vertical' as const, categories: ['ui'] },
  { name: 'mini-player' as const, categories: ['multimedia'] },
  { name: 'minimize-alt' as const, categories: ['ui'] },
  { name: 'minimize' as const, categories: ['ui'] },
  { name: 'modem' as const, categories: ['devices'] },
  { name: 'moon' as const, categories: ['misc'] },
  { name: 'more-alt' as const, categories: ['ui'] },
  { name: 'more-r' as const, categories: ['ui'] },
  { name: 'more-vertical-alt' as const, categories: ['ui'] },
  { name: 'more-vertical-r' as const, categories: ['ui'] },
  { name: 'more-vertical' as const, categories: ['ui'] },
  { name: 'more' as const, categories: ['ui'] },
  { name: 'mouse' as const, categories: ['devices'] },
  { name: 'move-down' as const, categories: ['ui'] },
  { name: 'move-left' as const, categories: ['ui'] },
  { name: 'move-right' as const, categories: ['ui'] },
  { name: 'move-task' as const, categories: ['ui'] },
  { name: 'move-up' as const, categories: ['ui'] },
  { name: 'music' as const, categories: ['multimedia'] },
  { name: 'music-note' as const, categories: ['multimedia'] },
  { name: 'music-speaker' as const, categories: ['multimedia'] },
  { name: 'nametag' as const, categories: ['ui'] },
  { name: 'notes' as const, categories: ['ui'] },
  { name: 'notifications' as const, categories: ['ui'] },
  { name: 'options' as const, categories: ['ui'] },
  { name: 'organisation' as const, categories: ['ui'] },
  { name: 'pacman' as const, categories: ['misc'] },
  { name: 'password' as const, categories: ['ui'] },
  { name: 'path-back' as const, categories: ['layout'] },
  { name: 'path-crop' as const, categories: ['layout'] },
  { name: 'path-divide' as const, categories: ['layout'] },
  { name: 'path-exclude' as const, categories: ['layout'] },
  { name: 'path-front' as const, categories: ['layout'] },
  { name: 'path-intersect' as const, categories: ['layout'] },
  { name: 'path-outline' as const, categories: ['layout'] },
  { name: 'path-trim' as const, categories: ['layout'] },
  { name: 'path-unite' as const, categories: ['layout'] },
  { name: 'pen' as const, categories: ['ui'] },
  { name: 'pentagon-bottom-left' as const, categories: ['misc'] },
  { name: 'pentagon-bottom-right' as const, categories: ['misc'] },
  { name: 'pentagon-down' as const, categories: ['misc'] },
  { name: 'pentagon-left' as const, categories: ['misc'] },
  { name: 'pentagon-right' as const, categories: ['misc'] },
  { name: 'pentagon-top-left' as const, categories: ['misc'] },
  { name: 'pentagon-top-right' as const, categories: ['misc'] },
  { name: 'pentagon-up' as const, categories: ['misc'] },
  { name: 'performance' as const, categories: ['ui'] },
  { name: 'phone' as const, categories: ['devices'] },
  { name: 'photoscan' as const, categories: ['devices'] },
  { name: 'piano' as const, categories: ['multimedia'] },
  { name: 'pill' as const, categories: ['misc'] },
  { name: 'pin-alt' as const, categories: ['ui'] },
  { name: 'pin-bottom' as const, categories: ['ui'] },
  { name: 'pin-top' as const, categories: ['ui'] },
  { name: 'pin' as const, categories: ['ui'] },
  { name: 'play-backwards' as const, categories: ['multimedia'] },
  { name: 'play-button-o' as const, categories: ['multimedia', 'circle'] },
  { name: 'play-button-r' as const, categories: ['multimedia', 'square'] },
  { name: 'play-button' as const, categories: ['multimedia'] },
  { name: 'play-forwards' as const, categories: ['multimedia'] },
  { name: 'play-list-add' as const, categories: ['multimedia'] },
  { name: 'play-list-check' as const, categories: ['multimedia'] },
  { name: 'play-list-remove' as const, categories: ['multimedia'] },
  { name: 'play-list-search' as const, categories: ['multimedia'] },
  { name: 'play-list' as const, categories: ['multimedia'] },
  { name: 'play-pause-o' as const, categories: ['multimedia', 'circle'] },
  { name: 'play-pause-r' as const, categories: ['multimedia', 'square'] },
  { name: 'play-pause' as const, categories: ['multimedia'] },
  { name: 'play-stop-o' as const, categories: ['multimedia', 'circle'] },
  { name: 'play-stop-r' as const, categories: ['multimedia', 'square'] },
  { name: 'play-stop' as const, categories: ['multimedia'] },
  { name: 'play-track-next-o' as const, categories: ['multimedia', 'circle'] },
  { name: 'play-track-next-r' as const, categories: ['multimedia', 'square'] },
  { name: 'play-track-next' as const, categories: ['multimedia'] },
  { name: 'play-track-prev-o' as const, categories: ['multimedia', 'circle'] },
  { name: 'play-track-prev-r' as const, categories: ['multimedia', 'square'] },
  { name: 'play-track-prev' as const, categories: ['multimedia'] },
  { name: 'plug' as const, categories: ['ui'] },
  { name: 'pokemon' as const, categories: ['misc'] },
  { name: 'polaroid' as const, categories: ['misc'] },
  { name: 'poll' as const, categories: ['ui'] },
  { name: 'presentation' as const, categories: ['ui'] },
  { name: 'printer' as const, categories: ['devices'] },
  { name: 'profile' as const, categories: ['ui'] },
  { name: 'pull-clear' as const, categories: ['ui'] },
  { name: 'push-chevron-down-o' as const, categories: ['ui', 'circle'] },
  { name: 'push-chevron-down-r' as const, categories: ['ui', 'square'] },
  { name: 'push-chevron-down' as const, categories: ['ui'] },
  { name: 'push-chevron-left-o' as const, categories: ['ui', 'circle'] },
  { name: 'push-chevron-left-r' as const, categories: ['ui', 'square'] },
  { name: 'push-chevron-left' as const, categories: ['ui'] },
  { name: 'push-chevron-right-o' as const, categories: ['ui', 'circle'] },
  { name: 'push-chevron-right-r' as const, categories: ['ui', 'square'] },
  { name: 'push-chevron-right' as const, categories: ['ui'] },
  { name: 'push-chevron-up-o' as const, categories: ['ui', 'circle'] },
  { name: 'push-chevron-up-r' as const, categories: ['ui', 'square'] },
  { name: 'push-chevron-up' as const, categories: ['ui'] },
  { name: 'push-down' as const, categories: ['ui'] },
  { name: 'push-left' as const, categories: ['ui'] },
  { name: 'push-right' as const, categories: ['ui'] },
  { name: 'push-up' as const, categories: ['ui'] },
  { name: 'qr' as const, categories: ['ui'] },
  { name: 'quote-o' as const, categories: ['ui'] },
  { name: 'quote' as const, categories: ['ui'] },
  { name: 'radio-check' as const, categories: ['ui'] },
  { name: 'radio-checked' as const, categories: ['ui'] },
  { name: 'ratio' as const, categories: ['ui'] },
  { name: 'read' as const, categories: ['misc'] },
  { name: 'readme' as const, categories: ['ui'] },
  { name: 'redo' as const, categories: ['ui'] },
  { name: 'remote' as const, categories: ['ui'] },
  { name: 'remove-r' as const, categories: ['ui', 'square'] },
  { name: 'remove' as const, categories: ['ui'] },
  { name: 'rename' as const, categories: ['ui'] },
  { name: 'reorder' as const, categories: ['ui'] },
  { name: 'repeat' as const, categories: ['ui'] },
  { name: 'ring' as const, categories: ['misc'] },
  { name: 'row-first' as const, categories: ['layout'] },
  { name: 'row-last' as const, categories: ['layout'] },
  { name: 'ruler' as const, categories: ['ui'] },
  { name: 'sand-clock' as const, categories: ['ui'] },
  { name: 'scan' as const, categories: ['ui'] },
  { name: 'screen-mirror' as const, categories: ['ui'] },
  { name: 'screen-shot' as const, categories: ['ui'] },
  { name: 'screen-wide' as const, categories: ['ui'] },
  { name: 'screen' as const, categories: ['ui'] },
  { name: 'scroll-h' as const, categories: ['ui'] },
  { name: 'scroll-v' as const, categories: ['ui'] },
  { name: 'search-found' as const, categories: ['ui'] },
  { name: 'search-loading' as const, categories: ['ui'] },
  { name: 'search' as const, categories: ['ui'] },
  { name: 'select-o' as const, categories: ['ui', 'circle'] },
  { name: 'select-r' as const, categories: ['ui', 'square'] },
  { name: 'select' as const, categories: ['ui'] },
  { name: 'server' as const, categories: ['ui'] },
  { name: 'shape-circle' as const, categories: ['misc'] },
  { name: 'shape-half-circle' as const, categories: ['misc'] },
  { name: 'shape-hexagon' as const, categories: ['misc'] },
  { name: 'shape-rhombus' as const, categories: ['misc'] },
  { name: 'shape-square' as const, categories: ['misc'] },
  { name: 'shape-triangle' as const, categories: ['misc'] },
  { name: 'shape-zigzag' as const, categories: ['misc'] },
  { name: 'share' as const, categories: ['ui'] },
  { name: 'shield' as const, categories: ['misc'] },
  { name: 'shopping-bag' as const, categories: ['ui'] },
  { name: 'shopping-cart' as const, categories: ['ui'] },
  { name: 'shortcut' as const, categories: ['ui'] },
  { name: 'sidebar-open' as const, categories: ['ui'] },
  { name: 'sidebar-right' as const, categories: ['ui'] },
  { name: 'sidebar' as const, categories: ['ui'] },
  { name: 'signal' as const, categories: ['ui'] },
  { name: 'size' as const, categories: ['ui'] },
  { name: 'sketch' as const, categories: ['misc'] },
  { name: 'sleep' as const, categories: ['ui'] },
  { name: 'smart-home-boiler' as const, categories: ['misc'] },
  { name: 'smart-home-cooker' as const, categories: ['misc'] },
  { name: 'smart-home-heat' as const, categories: ['misc'] },
  { name: 'smart-home-light' as const, categories: ['misc'] },
  { name: 'smart-home-refrigerator' as const, categories: ['misc'] },
  { name: 'smart-home-wash-machine' as const, categories: ['misc'] },
  { name: 'smartphone' as const, categories: ['devices'] },
  { name: 'smartphone-chip' as const, categories: ['devices'] },
  { name: 'smartphone-ram' as const, categories: ['devices'] },
  { name: 'smartphone-shake' as const, categories: ['devices'] },
  { name: 'smile-mouth-open' as const, categories: ['ui'] },
  { name: 'smile-neutral' as const, categories: ['ui'] },
  { name: 'smile-no-mouth' as const, categories: ['ui'] },
  { name: 'smile-none' as const, categories: ['ui'] },
  { name: 'smile-sad' as const, categories: ['ui'] },
  { name: 'smile-upside' as const, categories: ['ui'] },
  { name: 'smile' as const, categories: ['ui'] },
  { name: 'software-download' as const, categories: ['ui'] },
  { name: 'software-upload' as const, categories: ['ui'] },
  { name: 'space-between-v' as const, categories: ['layout'] },
  { name: 'space-between' as const, categories: ['layout'] },
  { name: 'spinner-alt' as const, categories: ['loaders'] },
  { name: 'spinner-two-alt' as const, categories: ['loaders'] },
  { name: 'spinner-two' as const, categories: ['loaders'] },
  { name: 'spinner' as const, categories: ['loaders'] },
  { name: 'stack' as const, categories: ['layout'] },
  { name: 'stopwatch' as const, categories: ['devices'] },
  { name: 'stories' as const, categories: ['ui'] },
  { name: 'style' as const, categories: ['ui'] },
  { name: 'sun' as const, categories: ['ui'] },
  { name: 'support' as const, categories: ['ui'] },
  { name: 'swap-vertical' as const, categories: ['ui'] },
  { name: 'swap' as const, categories: ['ui'] },
  { name: 'sync' as const, categories: ['ui'] },
  { name: 'tab' as const, categories: ['ui'] },
  { name: 'tap-double' as const, categories: ['ui'] },
  { name: 'tap-single' as const, categories: ['ui'] },
  { name: 'template' as const, categories: ['ui'] },
  { name: 'tennis' as const, categories: ['misc'] },
  { name: 'terminal' as const, categories: ['development'] },
  { name: 'terrain' as const, categories: ['misc'] },
  { name: 'thermometer' as const, categories: ['misc'] },
  { name: 'thermostat' as const, categories: ['misc'] },
  { name: 'tikcode' as const, categories: ['misc'] },
  { name: 'time' as const, categories: ['ui'] },
  { name: 'timelapse' as const, categories: ['ui'] },
  { name: 'timer' as const, categories: ['ui'] },
  { name: 'today' as const, categories: ['ui'] },
  { name: 'toggle-off' as const, categories: ['ui'] },
  { name: 'toggle-on' as const, categories: ['ui'] },
  { name: 'toggle-square-off' as const, categories: ['ui'] },
  { name: 'toggle-square' as const, categories: ['ui'] },
  { name: 'toolbar-bottom' as const, categories: ['ui'] },
  { name: 'toolbar-left' as const, categories: ['ui'] },
  { name: 'toolbar-right' as const, categories: ['ui'] },
  { name: 'toolbar-top' as const, categories: ['ui'] },
  { name: 'toolbox' as const, categories: ['ui'] },
  { name: 'touchpad' as const, categories: ['devices'] },
  { name: 'track' as const, categories: ['ui'] },
  { name: 'transcript' as const, categories: ['ui'] },
  { name: 'trash-empty' as const, categories: ['ui'] },
  { name: 'trash' as const, categories: ['ui'] },
  { name: 'tree' as const, categories: ['misc'] },
  { name: 'trees' as const, categories: ['misc'] },
  { name: 'trending-down' as const, categories: ['ui'] },
  { name: 'trending' as const, categories: ['ui'] },
  { name: 'tv' as const, categories: ['devices'] },
  { name: 'ui-kit' as const, categories: ['misc'] },
  { name: 'umbrella' as const, categories: ['misc'] },
  { name: 'undo' as const, categories: ['ui'] },
  { name: 'usb' as const, categories: ['devices'] },
  { name: 'usb-c' as const, categories: ['devices'] },
  { name: 'user-add' as const, categories: ['ui'] },
  { name: 'user-list' as const, categories: ['ui'] },
  { name: 'user-remove' as const, categories: ['ui'] },
  { name: 'user' as const, categories: ['ui'] },
  { name: 'view-cols' as const, categories: ['layout'] },
  { name: 'view-comfortable' as const, categories: ['layout'] },
  { name: 'view-day' as const, categories: ['layout'] },
  { name: 'view-grid' as const, categories: ['layout'] },
  { name: 'view-list' as const, categories: ['layout'] },
  { name: 'view-month' as const, categories: ['layout'] },
  { name: 'view-split' as const, categories: ['layout'] },
  { name: 'voicemail-o' as const, categories: ['ui', 'circle'] },
  { name: 'voicemail-r' as const, categories: ['ui'] },
  { name: 'voicemail' as const, categories: ['ui'] },
  { name: 'website' as const, categories: ['ui'] },
  { name: 'work-alt' as const, categories: ['ui'] },
  { name: 'yinyang' as const, categories: ['misc'] },
  { name: 'zoom-in' as const, categories: ['ui'] },
  { name: 'zoom-out' as const, categories: ['ui'] },
];

export const iconsCustom = [
  { name: 'accessibility' as const, categories: ['ui', 'circle'] },
  { name: 'add' as const, categories: ['ui', 'circle'] },
  { name: 'add-r' as const, categories: ['ui', 'square'] },
  { name: 'airplane' as const, categories: ['misc'] },
  { name: 'angular' as const, categories: ['development'] },
  { name: 'apple' as const, categories: ['brand'] },
  { name: 'atlassian' as const, categories: ['development'] },
  { name: 'bamboo' as const, categories: ['development'] },
  { name: 'bitbucket' as const, categories: ['development'] },
  { name: 'block' as const, categories: ['ui', 'circle'] },
  { name: 'bullseye' as const, categories: ['misc'] },
  { name: 'bullseye-arrow' as const, categories: ['misc'] },
  { name: 'c-plus-plus' as const, categories: ['development'] },
  { name: 'camera' as const, categories: ['devices', 'multimedia'] },
  { name: 'camera-alt' as const, categories: ['devices', 'multimedia'] },
  { name: 'categories' as const, categories: ['ui'] },
  { name: 'check' as const, categories: ['ui'] },
  { name: 'chevron-double-down' as const, categories: ['arrows'] },
  { name: 'chevron-double-left' as const, categories: ['arrows'] },
  { name: 'chevron-double-right' as const, categories: ['arrows'] },
  { name: 'chevron-double-up' as const, categories: ['arrows'] },
  { name: 'circle-ci' as const, categories: ['development'] },
  { name: 'code-climate' as const, categories: ['development'] },
  { name: 'codepen' as const, categories: ['development'] },
  { name: 'codesandbox' as const, categories: ['development'] },
  { name: 'cog' as const, categories: ['ui'] },
  { name: 'cross' as const, categories: ['misc'] },
  { name: 'danger' as const, categories: ['ui', 'circle'] },
  { name: 'digital-ocean' as const, categories: ['development'] },
  { name: 'discord' as const, categories: ['brand'] },
  { name: 'dribble' as const, categories: ['brand'] },
  { name: 'dropbox' as const, categories: ['brand'] },
  { name: 'facebook' as const, categories: ['brand'] },
  { name: 'figma' as const, categories: ['brand'] },
  { name: 'format-bold' as const, categories: ['typography'] },
  { name: 'framer' as const, categories: ['brand'] },
  { name: 'ghost' as const, categories: ['misc'] },
  { name: 'git' as const, categories: ['development'] },
  { name: 'github' as const, categories: ['development'] },
  { name: 'github-actions' as const, categories: ['development'] },
  { name: 'github-copilot' as const, categories: ['development'] },
  { name: 'gitlab' as const, categories: ['development'] },
  { name: 'gitter' as const, categories: ['development'] },
  { name: 'glass' as const, categories: ['misc'] },
  { name: 'google' as const, categories: ['brand'] },
  { name: 'google-calendar' as const, categories: ['brand'] },
  { name: 'google-drive' as const, categories: ['brand'] },
  { name: 'google-meet' as const, categories: ['brand'] },
  { name: 'heart-filled' as const, categories: ['ui'] },
  { name: 'info' as const, categories: ['ui', 'circle'] },
  { name: 'instagram' as const, categories: ['brand'] },
  { name: 'invision' as const, categories: ['brand'] },
  { name: 'javascript' as const, categories: ['development'] },
  { name: 'jenkins' as const, categories: ['development'] },
  { name: 'jest' as const, categories: ['development'] },
  { name: 'jsfiddle' as const, categories: ['development'] },
  { name: 'keyhole' as const, categories: ['ui', 'circle'] },
  { name: 'kotlin' as const, categories: ['development'] },
  { name: 'linkedin' as const, categories: ['brand'] },
  { name: 'loadbar' as const, categories: ['loaders'] },
  { name: 'loadbar-alt' as const, categories: ['loaders'] },
  { name: 'loadbar-doc' as const, categories: ['loaders'] },
  { name: 'loadbar-sound' as const, categories: ['loaders'] },
  { name: 'loom' as const, categories: ['brand'] },
  { name: 'markdown' as const, categories: ['development'] },
  { name: 'menu-close' as const, categories: ['ui'] },
  { name: 'menu-open' as const, categories: ['ui'] },
  { name: 'menu-round' as const, categories: ['ui', 'circle'] },
  { name: 'messenger' as const, categories: ['brand'] },
  { name: 'meta' as const, categories: ['brand'] },
  { name: 'mic' as const, categories: ['devices', 'multimedia'] },
  { name: 'mic-muted' as const, categories: ['devices', 'multimedia'] },
  { name: 'microsoft' as const, categories: ['brand'] },
  { name: 'microsoft-teams' as const, categories: ['brand'] },
  { name: 'microsoft-windows' as const, categories: ['brand'] },
  { name: 'money-sign' as const, categories: ['misc'] },
  { name: 'more-o' as const, categories: ['ui', 'circle'] },
  { name: 'more-vertical-o' as const, categories: ['ui', 'circle'] },
  { name: 'next.js' as const, categories: ['development'] },
  { name: 'node.js' as const, categories: ['development'] },
  { name: 'npm' as const, categories: ['development'] },
  { name: 'password-alt' as const, categories: ['ui'] },
  { name: 'patreon' as const, categories: ['brand'] },
  { name: 'paypal' as const, categories: ['brand'] },
  { name: 'product-hunt' as const, categories: ['brand'] },
  { name: 'python' as const, categories: ['development'] },
  { name: 'react' as const, categories: ['development'] },
  { name: 'record' as const, categories: ['multimedia', 'circle'] },
  { name: 'redux' as const, categories: ['development'] },
  { name: 'rocket-chat' as const, categories: ['brand'] },
  { name: 'rust' as const, categories: ['development'] },
  { name: 'send' as const, categories: ['ui'] },
  { name: 'send-alt' as const, categories: ['ui'] },
  { name: 'serverless' as const, categories: ['development'] },
  { name: 'skype' as const, categories: ['brand'] },
  { name: 'slack' as const, categories: ['brand'] },
  { name: 'sort' as const, categories: ['ui'] },
  { name: 'sort-asc' as const, categories: ['ui'] },
  { name: 'sort-desc' as const, categories: ['ui'] },
  { name: 'spotify' as const, categories: ['brand'] },
  { name: 'square' as const, categories: ['brand'] },
  { name: 'star' as const, categories: ['ui'] },
  { name: 'svelte' as const, categories: ['development'] },
  { name: 'swift' as const, categories: ['development'] },
  { name: 'tag' as const, categories: ['ui'] },
  { name: 'tags' as const, categories: ['ui'] },
  { name: 'thumbs-down' as const, categories: ['ui'] },
  { name: 'thumbs-up' as const, categories: ['ui'] },
  { name: 'tidal' as const, categories: ['brand'] },
  { name: 'travis-ci' as const, categories: ['development'] },
  { name: 'trello' as const, categories: ['brand'] },
  { name: 'trophy' as const, categories: ['misc'] },
  { name: 'tumblr' as const, categories: ['brand'] },
  { name: 'twilio' as const, categories: ['development'] },
  { name: 'twitch' as const, categories: ['brand'] },
  { name: 'twitter' as const, categories: ['brand'] },
  { name: 'typescript' as const, categories: ['development'] },
  { name: 'unavailable' as const, categories: ['ui', 'circle'] },
  { name: 'unblock' as const, categories: ['ui', 'circle'] },
  { name: 'vector' as const, categories: ['ui'] },
  { name: 'vercel' as const, categories: ['development'] },
  { name: 'video-camera' as const, categories: ['devices', 'multimedia'] },
  { name: 'vimeo' as const, categories: ['brand'] },
  { name: 'vinyl' as const, categories: ['multimedia'] },
  { name: 'vscode' as const, categories: ['development'] },
  { name: 'vue' as const, categories: ['development'] },
  { name: 'volume-low' as const, categories: ['multimedia'] },
  { name: 'volume-mid' as const, categories: ['multimedia'] },
  { name: 'volume-high' as const, categories: ['multimedia'] },
  { name: 'webcam' as const, categories: ['devices', 'multimedia'] },
  { name: 'webstorm' as const, categories: ['development'] },
  { name: 'whatsapp' as const, categories: ['brand'] },
  { name: 'wheelchair' as const, categories: ['ui'] },
  { name: 'workplace' as const, categories: ['brand'] },
  { name: 'youtube' as const, categories: ['brand'] },
  { name: 'zoom' as const, categories: ['brand'] },
];

export const icons = [...iconsCustom, ...iconsPack].sort(sortByLocaleCompare('name'));

export const inputTypes = [
  'color',
  'date',
  'email',
  'file',
  'hidden',
  'number',
  'password',
  'search',
  'tel',
  'text',
] as const;

export const sizes = ['sm', 'md', 'lg'] as const;

export const textSizes = ['small', 'mid', 'regular', 'large'] as const;

export const textDefaultOptions = {
  bold: false,
  italic: false,
  size: 'regular' as const,
};
